export default __webpack_public_path__ + "locales/vi/Ldap.json?hash=d036605409d7fff79c132204ba29cdd7";